import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css"; // Slick carousel styles
import "slick-carousel/slick/slick-theme.css"; // Slick carousel theme styles
import classes from "./Batafsil.module.css";
import classerror from "../../../shared/pages/Error404Page.module.css";
import Error404Animation from "../../../shared/assets/animated-placeholders/Error404.json";
import { useNavigate } from "react-router-dom";
import LottieView from "lottie-react";
import { testUrl } from "../BaseData";
import styles from "./newsClasses.module.css";
import moment from "moment";
import { InlineIcon } from "@iconify/react/dist/iconify.js";

const NewsDetails = () => {
    const { new_id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(); // Access i18n instance
    const [new_data, setNew] = useState(null);
    const [relatedNews, setRelatedNews] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        setError(null);
        setLoading(true);
        const fetchNew = axios.get(
            testUrl + "/api/news/" + new_id
        );
        const fetchRelatedNews = axios.get(
            testUrl + "/api/news/"
        );

        Promise.all([fetchNew, fetchRelatedNews])
            .then(([newResponse, relatedResponse]) => {
                const responseData = newResponse.data;
                const relatedData = relatedResponse.data;
                if (responseData && relatedData) {
                    setNew(responseData);
                    // Filter out the current news and limit to 5 items
                    const filtered = relatedData.filter(news => news.id !== parseInt(new_id));
                    setRelatedNews(filtered.slice(0, 5));
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));
    }, [new_id, i18n.language]);



    const getNewTitle = (news) => {
        if (!news) return t("no_name_available");
        const title = news[`title_${i18n.language}`];
        return title || news.title_uz || t("no_name_available");
    };

    if (loading) return <p>Yuklanmoqda...</p>;

    // Add null check for new_data
    if (!new_data) {
        return <p>Yangilik ma'lumotlari topilmadi</p>;
    }

    if (error) return (
        <div className={classerror["error-page"]}>
            <LottieView className={classerror["animation"]}
                animationData={Error404Animation}
                loop={true}
            />
            <p className={classerror["title"]}>
                {t("sorry")}
            </p>
            <p className={classerror["description"]}>
                {t("back_main")}
            </p>
            <div onClick={() => navigate("/")} className={classerror["button"]}>
                {t("main_menu")}
            </div>
        </div>
    )

    return (
        <div className={classes.mainContainer}>
            <div className={classes.sidebar}>
                <h3>{t("Boshqa yangiliklar")}</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    {relatedNews && relatedNews.length > 0 ? (
                        relatedNews.map((news) => (
                            <li
                                key={news.id}
                                onClick={() => navigate(`/news/${news.id}`)}
                                style={{
                                    marginBottom: '0',
                                    cursor: 'pointer',
                                    background: '#ffffff',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)'
                                }}
                            >
                                <div style={{ padding: '12px' }}>
                                    <img
                                        src={news.image}
                                        alt={getNewTitle(news)}
                                        style={{
                                            width: '100%',
                                            height: '140px',
                                            objectFit: 'cover',
                                            borderRadius: '6px',
                                            marginBottom: '10px'
                                        }}
                                    />
                                    <h4 style={{
                                        margin: 0,
                                        fontSize: '14px',
                                        color: '#2c3e50',
                                        lineHeight: '1.5',
                                        fontWeight: '600',
                                        marginBottom: '8px'
                                    }}>
                                        {getNewTitle(news)}
                                    </h4>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#6c757d',
                                        display: 'block',
                                        fontWeight: '500'
                                    }}>
                                        {moment(news.posted_time)
                                            .locale(i18n.language)
                                            .format("DD-MMMM, HH:mm")}
                                    </span>
                                </div>
                            </li>
                        ))
                    ) : (
                        <li>{t("no_news_found")}</li>
                    )}
                </ul>
            </div>
            <div data-aos="fade-up" className={classes["rahbariyat-container"]}>
                <h1 className={classes["page-title"]}>
                    {new_data && new_data[`title_${i18n.language}`]}
                </h1>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '40px',
                    margin: '25px 0',
                    padding: '18px 30px',
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                    borderRadius: '10px',
                    borderLeft: '4px solid #133654',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
                }}>
                    <span style={{ 
                        color: '#2c3e50',
                        fontSize: '15px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <InlineIcon icon="mdi:view-grid" width="16" height="16" color="#2c3e50" />
                        {new_data.category?.[`name_${i18n.language}`] || new_data.category?.name_uz || ''}
                    </span>
                    <span style={{ 
                        color: '#2c3e50',
                        fontSize: '15px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        {moment(new_data.posted_time)
                            .locale(i18n.language)
                            .format("DD-MMMM, HH:mm")}
                    </span>
                    <span style={{ 
                        color: '#2c3e50',
                        fontSize: '15px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <InlineIcon icon="mdi:eye" width="18" height="18" color="#2c3e50" />
                        {new_data.view_count} views
                    </span>
                </div>
                <div dangerouslySetInnerHTML={{
                    __html: new_data && new_data[`full_news_${i18n.language}`] ? new_data[`full_news_${i18n.language}`] : '',
                }} />
            </div>
        </div>
    );
};

export default NewsDetails;